<template>
  <div class="content-wrapper">
    <div class="content">
      <organization></organization>
      <experts></experts>
      <member></member>
    </div>
    <img src="~@/assets/images/leftF.png" class="leftF" />
    <img src="~@/assets/images/rightF.png" class="rightF" />
  </div>
</template>

<script>
import Bread from "./Bread.vue";
import Organization from "../../components/index/Organization.vue";
import Experts from "../index/Experts.vue";
import Member from "../../components/index/MemberDistribution.vue";
export default {
  components: {
    Bread,
    Organization,
    Experts,
    Member,
  },
  name: "orgs",
  data() {
    return {
      list: [
        {
          url: require("../../assets/images/history/1.png"),
          title:
            "Working Group 46: Joint PICES/ICES Working Group on Ocean Negative Carbon Emissions (ONCE)",
          article:
            " The Working Group 46 a joint PICES/ICES working group on Ocean Negative Carbon Emissions (ONCE) was formed with all members been officially assigned on 6th April 2021. WGONCE has consisted of 25 members including two Co-Chairs representing PICES, Drs. Nianzhi Jiao (China) and Douglas Wallace (Canada), and the two Co-Chairs representing ICES, Drs. Carol Robinson (UK) and Louis Legendre (France)....",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgb(0 0 0 / 10%);
}
.content-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.content {
  z-index: 2;
}
.list {
  position: relative;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.leftF {
  left: 0;
  position: absolute;
  width: 495px;
  /* height: 832px; */
  top: 135px;
  z-index: 1;
  height: 1519px;
}

.rightF {
  position: absolute;
  width: 252px;
  top: 65px;
  z-index: 0;
  right: 1;
  height: 1119px;
  right: 0;
}

/deep/.el-menu {
  background-color: unset;
}
</style>
